// Todos los textos de UI en un solo lugar (rioplatense).
// Nombre comercial: FluxAyuda (también en index.html, manifest.webmanifest y sw.js).
export const strings = {
  appName: "FluxAyuda",
  headerTitle: "FluxAyuda",
  headerSubtitleBot: "Respuesta inmediata",
  headerSubtitleAgent: "Te atiende una persona",

  composerPlaceholder: "Escribí tu consulta…",
  composerPlaceholderId: "Nº de abonado (6 dígitos) o DNI",
  send: "Enviar",

  abonadoLabel: (id) => `Abonado ${id}`,
  toggleTheme: "Cambiar tema claro/oscuro",
  listPickerOpen: "Ver opciones",
  listPickerTitle: "Elegí una opción",
  listPickerClose: "Cerrar",

  connecting: "Conectando…",
  loadingHistory: "Cargando mensajes anteriores…",
  today: "Hoy",
  yesterday: "Ayer",
  offline: "Sin conexión. Tu conversación sigue acá cuando vuelvas a tener internet.",
  messageFailed: "No se pudo enviar. Tocá para reintentar.",
  retry: "Reintentar",
  agentConnected: "Un agente se sumó a la conversación",
  handoffActive: "El asistente automático vuelve al terminar.",
  agentLabel: "Agente",
  agentBanner: (name) => name ? `Te atiende ${name}` : "Te atiende una persona",

  attach: "Adjuntar archivo",
  attachTooBig: "El archivo es muy grande (máx 6 MB).",
  attachUnsupported: "Formato no soportado: mandá una foto (JPG/PNG) o un PDF.",
  attachQuotaExceeded: "Ya enviaste muchos archivos en esta conversación. Pedile a un agente que siga por otro medio.",
  uploading: "Subiendo…",

  attachDownload: "Descargar",
  attachDownloading: "Descargando…",
  attachmentUnavailable: "Este archivo ya no está disponible (los adjuntos se guardan 30 días).",

  csatQuestion: "¿Cómo calificás la atención?",
  csatBad: "Mal",
  csatNeutral: "Regular",
  csatGood: "Excelente",
  csatThanks: "¡Gracias por tu calificación!",
  attachmentSent: (fileName) => `Adjunto: ${fileName}`,

  pushBannerText: "¿Te avisamos cuando te respondan, aunque cierres esta pestaña?",
  pushEnable: "Avisarme",
  pushDismiss: "Ahora no",
  pushDenied: "En esta ventana no se pueden activar los avisos (por ejemplo, en modo incógnito o si los bloqueaste en el navegador). La respuesta igual te aparece acá en el chat.",
  pushFeedbackOk: "Entendido",
  pushError: "No pudimos activar los avisos. Probá de nuevo en unos segundos.",

  installBannerText: "Instalá FluxAyuda para tenerla a mano en tu pantalla de inicio.",
  installAction: "Instalar",
  // Sin diálogo nativo de instalación: instrucciones para hacerlo a mano.
  installHintIos: "Instalá FluxAyuda: tocá Compartir y elegí «Agregar a inicio».",
  installHintBrowser: "Instalá FluxAyuda desde el menú del navegador, opción «Instalar app».",

  errorStart: "No pudimos iniciar la conversación. Probá de nuevo en unos segundos.",
  errorGeneric: "Algo salió mal. Probá de nuevo.",
  accountMenu: "Opciones de la cuenta",
  switchAccount: "Consultar por otra cuenta",
  switchAccountHint: "Te pedimos el Nº de abonado o DNI de la otra cuenta.",
  switchAccountConfirmTitle: "¿Consultar por otra cuenta?",
  switchAccountConfirmBody: "Vamos a borrar esta conversación de este dispositivo y te vamos a pedir el Nº de abonado o DNI de la otra cuenta.",
  switchAccountConfirmAction: "Sí, cambiar de cuenta",
  logout: "Cerrar sesión",
  logoutHint: "Salís de la cuenta y el chat queda cerrado en este dispositivo.",
  logoutConfirmTitle: "¿Cerrar sesión?",
  logoutConfirmBody: "Vamos a borrar esta conversación de este dispositivo. Para volver a consultar vas a tener que identificarte de nuevo.",
  logoutConfirmAction: "Cerrar sesión",
  closeSessionHandoffWarning: "La atención con el agente se va a cortar.",
  sessionClosed: "Cerraste la sesión y borramos la conversación de este dispositivo.",
  startAgain: "Empezar de nuevo",
  cancel: "Cancelar",

  linkReused: "Este link ya se usó. Entraste a la cuenta, pero para ver facturas y datos personales vas a tener que validar tu identidad.",
  linkExpired: "El link de acceso ya se usó o venció. No pasa nada: podés identificarte acá mismo con tu número de abonado o DNI.",
  linkError: "No pudimos validar tu link en este momento. Volvé a tocarlo en unos minutos o identificate acá mismo."
};
